import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import LeftCircleArrow from '../svgs/LeftCircleArrow'
import RightCircleArrow from '../svgs/RightCircleArrow'
import * as styles from './postNavigation.module.scss'

function PostNavigation({
  link,
  imageSrc,
  title,
  categories,
  buttonLeft,
  buttonRight,
}) {
  return (
    <div className={`${styles.navigationContainer}`}>
      <div className={`${styles.arrowContainer}`}>
        <Link
          className={`d-flex align-items-center ${styles.arrowLinkContainer}`}
          to={`/blog/${link}`}
        >
          {buttonLeft ? (
            <LeftCircleArrow className={`${styles.arrowLink} ${styles.prvArrow}`} />
          ) : null}
          {buttonRight ? (
            <RightCircleArrow className={`${styles.arrowLink} ${styles.nextArrow}`} />
          ) : null}
        </Link>
      </div>
      {imageSrc ? (
        <div className={`${styles.imgContainer}`}>
          <img className={`${styles.navImg}`} src={imageSrc} alt={title} />
        </div>
      ) : null}
      <div className={`${styles.linkMainContainer}`}>
        {categories ? (
          <div className={`${styles.linkContainer}`}>
            {categories.map((cat) => (
              <Link
                className={`${styles.categoriesLink}`}
                key={cat}
                to={`/blog/category/${cat.slug}`}
                // to={`/blog/category/${cat.split(' ').join('-').toLowerCase()}`}
              >
                {cat.name}
              </Link>
            ))}
          </div>
        ) : null}
        <div className={`${styles.linkTitleContainer}`}>
          <Link className={`${styles.categoriesLink}`} to={`/blog/${link}`}>
            {title}
          </Link>
        </div>
      </div>
    </div>
  )
}

PostNavigation.propTypes = {
  link: PropTypes.string.isRequired,
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  categories: PropTypes.instanceOf(Array),
  buttonLeft: PropTypes.bool,
  buttonRight: PropTypes.bool,
}

PostNavigation.defaultProps = {
  imageSrc: null,
  title: null,
  categories: null,
  buttonLeft: false,
  buttonRight: false,
}

export default PostNavigation
